module.exports = __webpack_public_path__ + "static/media/Capture.4ce2119d.PNG";